var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 24,
    viewBox: "0 0 13 24",
    fill: "fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99985 24C1.86824 24.0007 1.73778 23.9755 1.61594 23.9257C1.4941 23.876 1.38329 23.8027 1.28985 23.71C1.19612 23.617 1.12172 23.5064 1.07096 23.3846C1.02019 23.2627 0.994049 23.132 0.994049 23C0.994049 22.868 1.02019 22.7373 1.07096 22.6154C1.12172 22.4935 1.19612 22.3829 1.28985 22.29L9.45985 14.12C10.0216 13.5575 10.3372 12.795 10.3372 12C10.3372 11.205 10.0216 10.4425 9.45985 9.87999L1.28985 1.71C1.10154 1.5217 0.995756 1.2663 0.995756 1C0.995756 0.7337 1.10154 0.478305 1.28985 0.290002C1.47815 0.101698 1.73355 -0.00408936 1.99985 -0.00408936C2.26615 -0.00408936 2.52154 0.101698 2.70985 0.290002L10.8798 8.45999C11.3455 8.92445 11.7149 9.4762 11.967 10.0837C12.219 10.6911 12.3488 11.3423 12.3488 12C12.3488 12.6577 12.219 13.3089 11.967 13.9163C11.7149 14.5238 11.3455 15.0755 10.8798 15.54L2.70985 23.71C2.61641 23.8027 2.50559 23.876 2.38375 23.9257C2.26192 23.9755 2.13145 24.0007 1.99985 24Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right_icon.9e0d0ebe1f1a448360cc3feec6f162fb.svg";
export { ForwardRef as ReactComponent };